import { AxiosResponse } from 'axios';
import { call, CallEffect, put, takeLatest } from 'redux-saga/effects';

import { MooseApiRoutes } from 'src/config/api.config';
import { isOffline } from 'src/helpers/cache.helpers';
import { replaceColonPrefixed } from 'src/helpers/message.helpers';
import { fetchRequest, HttpMethod } from 'src/state/sagas/network/network.saga';
import { actionStatusAdd } from 'src/state/store/actionStatus/actionStatus.action';
import { ActionStatusEnum, ActionType } from 'src/state/store/actionStatus/actionStatus.type';
import { ACTION_OUTGOING_REFUND_REQUEST } from 'src/state/store/outgoing/outgoing.const';
import { authorize } from 'src/state/sagas/auth/authorization.saga';
import { OutgoingRefundRequestActionType } from 'src/state/store/outgoing/outgoing.type';

export function* outgoingRefundRequestSaga() {
	yield takeLatest(ACTION_OUTGOING_REFUND_REQUEST, outgoingRefundRequestWorker);
}

function* outgoingRefundRequestWorker(action: ActionType<OutgoingRefundRequestActionType>) {
	yield put(actionStatusAdd({ type: ACTION_OUTGOING_REFUND_REQUEST }, ActionStatusEnum.RUNNING, isOffline()));

	try {
		if (!action.payload) {
			return;
		}

		const { orderUuid, formdata } = action.payload;

		yield call(sendRefundRequest, orderUuid, formdata);

		yield put(actionStatusAdd({ type: ACTION_OUTGOING_REFUND_REQUEST }, ActionStatusEnum.SUCCESS));
	} catch (error) {
		yield put(actionStatusAdd({ type: ACTION_OUTGOING_REFUND_REQUEST }, ActionStatusEnum.ERROR, isOffline()));
	}
}

function* sendRefundRequest(orderUuid: string, formdata: FormData): Generator<CallEffect<any>, AxiosResponse, any> {
	return yield call(
		fetchRequest,
		{
			method: HttpMethod.Post,
			url: replaceColonPrefixed(MooseApiRoutes.Refund, { orderUuid }),
			headers: {
				'Content-Type': 'multipart/form-data',
			},
			data: formdata,
		},
		[authorize],
	);
}
